// Russian

export default {
  component: {

    supportLink: 'support@recright.ru',

    layout: {
      endTime: date => (date ? `крайний срок подачи заявок ${date}` : ''),
    },
    interview: {
      title: 'Ответить на видеоинтервью',
      submit: 'Отправить ответы и завершить интервью',
      privacyLinkText: 'Политика обработки персональных данных',
      continueLater: 'Продолжить позже',
      startInterview: 'Начать интервью',
      duplicateError: 'Вы уже приняли участие в данном интервью. Вы получили электронное письмо от invitations@recright.com, содержащее ссылку, которая может быть использована для продолжения интервью.',
      confirmSubmitHeader: 'Вы ответили не на все вопросы',
      confirmSubmitContent: 'Вы действительно хотите окончить интервью?',
      confirmSubmitContentWarning: 'После этого Вы уже не сможете дополнить свои ответы.',
      submitInterviewHeader: 'Отправить ответы на вопросы',
      submitInterviewContent: 'Вы уверены, что хотите отправить свои ответы?',
      confirmSubmitButton: 'Отправить ответы и завершить интервью',
      preview: 'Предварительно посмотреть на видео-вопросы можно здесь.',
      requiredQuestionsNotAnswered: 'Пожалуйста, ответьте на все обязательные вопросы перед отправкой.',

      withdrawLink: 'Вас больше не интересует данная вакансия? Снимите свою заявку на данную вакансию здесь.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      city: 'Город',
      link: 'Ссылка на сайт',
      legendBasicInfo: 'Общие данные',
      placeholderName: 'Введите Ваше имя',
      placeholderEmail: 'Введите Ваш email',
      placeholderPhone: 'Введите Ваш номер телефона',
      placeholderCity: 'Введите свой текущий город проживания',
      placeholderLink: 'Добавить ссылку, например, на Ваш профиль в LinkedIn.',
      legendAdditionalFields: 'Дополнительные данные',
      legendAttachments: 'Вложения',
      required: 'Обозначенные звездочкой * поля являются обязательными для заполнения.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Аудио',
        video: 'Видео',
        yes: 'Да',
        no: 'Нет',
        supported: 'Поддерживается',
        quality: 'Качество',
        header: 'Диагностический тест сети и устройства',
        description: 'Сейчас будет проведён диагностический тест вашего сетевого подключения и работы аппаратного оборудования (камеры и микрофона), необходимого для записи собеседования. Когда появится текст с соответствующей просьбой, разрешите тесту использовать камеру и микрофон устройства, а также проверьте, не заслонён ли объектив камеры. Тест займёт около 30 секунд. Попробуйте сказать несколько слов во время теста.',
        inProgress: 'Тест выполняется...',
        networkTestResults: 'Результаты теста сети',
        qualityTestResults: 'Результаты теста по качеству',
        testPassedQuality: 'Тест по качеству пройден',
        testFailedQuality: 'Тест по качеству связи не пройден',
        testPassedNetwork: 'Тест сети пройден',
        testFailedNetwork: 'Тест сети не пройден',
        startTest: 'Начать тест',
        startInterview: 'Начать собеседование',
        testAgain: 'Выполнить тест заново',
        confirmWarning: 'В начале видео-собеседования вы будете переведены к первому вопросу. После этого вы перейдёте к подготовке ответа на вопрос.',
        confirmTitle: 'Собеседование скоро начнётся',
        confirmText: 'У вас будет несколько минут для подготовки ответа на каждый из вопросов собеседования. После этого вам предоставят время на запись ответа. Заметьте, что ответ можно отправить сразу же после его записи. Необязательно ждать истечения всего времени, предоставленного на ответ.',
        confirmText2: 'После отправки ответа вы перейдёте к следующему вопросу, пока не ответите на все вопросы.',
        confirmText3:
          'Обращаем внимание на то, что после записи первого ответа у вас будет 30 секунд на повторный ответ, если это позволено для данного вопроса. Если в течение 30 секунд повторного ответа не последует, то текущий ответ будет отправлен автоматически и вас переведут к следующему вопросу.',
        goodLuck: 'Сделайте глубокий вдох – у вас всё получится! Удачи!',
        qualityRating: {
          excellent: 'Превосходное',
          good: 'Хорошее',
          fair: 'Удовлетворительное',
          poor: 'Низкое',
          bad: 'Плохое',
        },
      },
      questionAnswerView: {
        title: title => `Ответьте на вопросы собеседования ${title}`,
        question: 'Вопрос',
        submitAndNext: 'Отправить и показать следующий',
        submitSuccess: 'Видео успешно отправлено!',
        skipText: 'Начать запись',
        stop: 'Стоп',
        submitAndFinish: 'Отправить и завершить собеседование',
        retake: 'Провести собеседование заново',
        take: 'Провести собеседование',
        takesLeft: 'Осталось попыток',
        skipTextQuestion: 'Готово? Перейти к следующему',
        retakeConfirmTitle: 'Вы уверены, что хотите заново ответить на этот вопрос?',
        retakeConfirmSubmit: 'Да, заново ответить',
        submitInfoForward: 'Автоматическая отправка текущего ответа и переход к следующему вопросу',
        submitInfoForward2: 'сек.',
        nonAnswerableText: 'На это сообщение не требуется отвечать. После этого сообщения вас перенаправят на следующий вопрос.',
        nonAnswerableVideo: 'На это видео не требуется отвечать. После этого видео вас перенаправят на следующий вопрос.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `У вас есть ${answerMinutes} мин. и ${answerSeconds} сек., чтобы ответить на вопрос.`,
      },
      publisher: {
        toNextQuestion: timer => `Переход к следующему вопросу через ${timer}`,
        recordingStarts: timer => `Запись начнётся через ${timer}`,
      },
      errors: {
        tooManyConnections: 'Данное соединение прервано, так как имеется другое соединение в другой вкладке или другом окне браузера.',
        unsupportedBrowser: 'К сожалению, данное действие не поддерживается вашим браузером. Пожалуйста, используйте другой браузер.',
        networkError: 'Нет интернет-подключения.',
        reconnecting: 'Связь с сетью прервана. Выполняется переподключение.',
        generalError: 'Возникла ошибка. Пожалуйста, обновите страницу и попробуйте выполнить действие снова.',
        allowMediaDevicesError: 'Не удалось выполнить запрос доступа к устройствам мультимедиа (камере или микрофону). Проверьте, разрешили ли вы браузеру доступ к камере и микрофону в настройках устройства.',
        noAvailableDevicesError: 'Камера или микрофон не найдены.',
        initPublisherError: 'Действие не выполнено из-за возникновения ошибки. Проверьте, предоставили ли вы браузеру право на использование вашей камеры и микрофона, а также что, не используются ли они другим приложением; после этого повторите попытку.',
      },
      browserInfo: {
        browserSupportTitle: 'Совместимость с браузерами',
        supportedBrowsers: 'Последние версии Chrome, Firefox, Safari и Edge поддерживаются диагностическим тестом и средой опроса',
        mobileSupported: 'Совместимость с мобильными браузерами',
        android: 'Android: поддерживаются Google Chrome (последняя опубликованная версия), Firefox (последняя опубликованная версия)',
        iOS: 'iOS: браузер Safari (последняя опубликованная версия)',
        latestVersion: 'Проверьте, пользуетесь ли вы самой последней версией браузера. Это необходимо для обеспечения гладкой работы среды опроса.',
        freezeInstruction: 'Если запись видео не запускается или в окне записи чёрный квадрат, обновите страницу.',
        unsupportedOnIos: 'Судя по всему, вы пользуетесь браузером на системе iOS, который не поддерживается. Пожалуйста, перейдите на Safari.',
        ieUnsupported: 'Судя по всему, вы пользуетесь Internet Explorer. Данный браузер, к сожалению, не поддерживается ни диагностическим тестом, ни средой опроса. Пожалуйста, перейдите на другой браузер.',
        qualityTestNotSupported: 'К сожалению, проведение диагностического теста не поддерживается используемым вами браузером. Вы можете пропустить тест качества видео и аудио и перейти прямо к собеседованию, или же перейдите на другой браузер.',
      },
      reconnectSuccess: 'Связь с сетью восстановлена!',
      continue: 'Продолжить',
    },

    withdraw: {
      title: 'Вас больше не интересует данная вакансия?',
      description: 'Снять заявку на вакансию',
      buttonText: 'Снять заявку на данную вакансию',
      thankYouTitle: 'Спасибо за уведомление!',
      thankYouText: 'Таким образом вы уведомили агентов по подбору персонала о снятии своей заявки на данную вакансию.',
      confirm: 'Вы действительно желаете выйти из процесса подбора сотрудника на данную вакансию? После снятия своей заявки вы не сможете отвечать на вопросы данного или любого другого собеседования для данной вакансии.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Представить',
      continue: 'Продолжить',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Спасибо за ваше видео ответ! Мы будем в контакте с вами в ближайшее время! ',
    },

    supportLink: 'support@recright.ru',

    finished: {
      title: 'Благодарим Вас за участие в интервью!',
      reopenDescription: 'Если вы закрыли собеседование случайно, ничего страшного! Его можно открыть заново, воспользовавшись кнопкой ниже!',
      reopenButtonText: 'Открыть заново',
      description1: 'Очень хорошо! Вы ответили на все вопросы, они отправлены получателю.',
      descriptionsupport: mailto => `Если Вы закрыли это интервью случайно, обратитесь в нашу службу поддержки клиентов ${mailto}, и мы повторно откроем Ваше интервью.`,
      descriptionfeedback: 'Нам важно Ваше мнение. Пожалуйста, оцените свой опыт прохождения видеоинтервью. Как бы Вы улучшили наш сервис?',
      feedbackbutton: 'Оставьте отзыв здесь',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Личное сообщение',
    },
    closed: {
      title: 'Интервью пройдено, либо его срок истек.',
      description: 'Видеоинтервью, на которое Вы были приглашены, неактуально, либо Вы уже отправили свою заявку ранее.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Ваше видеоинтервью сохранено!',
      description: 'Если Вы хотите продолжить видеоинтервью, используйте ссылку, которую Вы ранее получили на свой адрес электронной почты. Вы можете вернуться к видеоответам, записанным ранее, при следующем посещении сайта. Желаем удачи!',
      remember: 'Не забудьте отправить ответы рекрутеру после того, как Вы закончите отвечать на интервью.',
      deleteHistory: 'Если Вы проходите видеоинтервью на общедоступном компьютере, не забудьте очистить историю просмотров в браузере. Таким образом, Ваше интервью будет в сохранности.',
    },
    unpublished: {
      title: 'Собеседование пока недоступно',
      publishTime: publishTime => `Собеседование станет доступно ${publishTime}`,
    },
  },
}
